export default __webpack_public_path__ + "static/media/disfigure.b56a8cb8.png";